export default __webpack_public_path__ + "static/t-yahoo-cd097c4dc1592efaf3528c72539898f7.png";